<template>
	<!-- This Page is For New Work Order and Skip Condition and Tanda Terima Only -->
	<div class="innerBox">
		<h2 class="mb-4">Formulir Work Order {{data.form_code ? `- ${data.form_code}` : ''}}</h2>

		<component
			:is="'page' + page"
			:data="data"
			:carType="carType"
			:page="page" 
			v-on:nextPage="nextPage"
			v-on:backPage="backPage"
			:checklistSettings="checklistSettings"
			@emitCQ="inputCQ"
			:merek="merek"
			:title="'Formulir Work Order'"
			@changeCarType="changeCarType"
			@correctFailUpload="individualCorrection"
			:apiLoading="apiLoading"
			:skip="skip"
			:getRecordedCondition="getRecordedCondition"
			:valid="valid"
			:value="progressValue"
		>
		</component>

		<upload-image
			v-if="modal.show"
			:title="modal.title"
			:endpoint="modal.endpoint"
			@onResponse="createWorkOrder"
			@closeModal="modal.show = false"
			:type="modal.type"
			:show_description="true"
			
		></upload-image>
	</div>
	
</template>

<script>
	import page1 from './workOrderFormPage/newPage1'
	import page2 from './workOrderFormPage/page2'
	import page3 from './workOrderFormPage/page3'
	import page4 from './workOrderFormPage/page4'
	import page5 from './workOrderFormPage/page5'
	import page6 from './workOrderFormPage/page6'
	import page7 from './workOrderFormPage/page7'
	import page8 from './workOrderFormPage/page8'
	import page9 from './workOrderFormPage/page9'
	import './workOrderFormPage/sedan.css'
	import './workOrderFormPage/minibus.css'
	import UploadImage from '@/components/modal/uploadImage'
	import env from '@/env'

	import moment from 'moment'
	// const translate = require('@vitalets/google-translate-api');

	export default {
		data () {
			let today = new moment().format('MMM, DD YYYY')
			let valid = new Array(8).fill(null)
			return {
				skip : false,
				
				page: 1,
				apiLoading : false ,
				modal : {
					show : false,
					title : 'Upload Gambar Depan',
					endpoint : env.urlStart + '/api/v1/workorder/steps/upload',
					type : null
				},
				
				merek : '',
				carType : 'sedan',
				customerRequest : '',
				getRecordedCondition : false,
				valid : valid,
				progressValue : 0,
				data: {
					CSO: '',
					finishDate : '-',
					serviceType : 'Mobil Menginap',
					form_code: null,
					conditionChecked : false,
					registration : '',
					customer: {
						name: '',
						alias: '',
						phone_number: '',
						created_at: today,
						last_date: today,
						ktp : '',
						ktp_img : '',
						email : ''
						
					},
					customer_car: {
						"chassis_number": '',
						"engine_number": '',
						"registration": '',
						colour : '',
						car_color_id : null,
						car_id: null,
						"current_km": '',
						"last_km": '0',
						"year": '',
						"brand": '',
						"type": '',
						stnk_img : '',
						// price : null,
						model : null,
						sim_img : ''
						
					},
					condition: {
						accu: {
							health : '0',
							charging : '0'
						},
						
						fuel: 'E',
						ttdCustomer : null,
						checklist: {},
						figureOverall : {
							sedan : {
								"front" : { image : []  },
								"rear" : { image : []  },
								"left" : { image : []  },
								"right" : { image : []  },
								'atap' : { image : []  }
							},
							minibus : {
								"front" : { image : []  },
								"rear" : { image : []  },
								"left" : { image : []  },
								"right" : { image : []  },
								'atap' : { image : []  }
							}
							
						},
						figure: {
							sedan : {
								front : {
									carWindowDepan : { desc : ''  },
									kapMesin : { desc : ''  },
									headLightKanan : { desc : ''  },
									grill : { desc : ''  } ,
									emblem : { desc : ''  },
									headLightKiri : { desc : ''  },
									bumperDepan : { desc : ''  },
									fogLightKiri : { desc : ''  },
									fogLightKanan : { desc : ''  },
									spionDepanKiri : { desc : ''  },
									spionDepanKanan : { desc : ''  },
								},
								rear : {
									carWindowBelakang : { desc : ''  },
									bagasi : { desc : ''  },
									backLightKiri : { desc : ''  },
									emblem : { desc : ''  },
									backLightKanan : { desc : ''  },
									bumperBelakang : { desc : ''  },
									bumperLightKiri : { desc : ''  },
									bumperLightKanan : { desc : ''  },
								},
								atap : {
									atapMobil : { desc : ''  },
									sunRoof : { desc : ''  }
								},
								left : {
									fenderDepanKiri : { desc : ''  },		
									rodaDepanKiri : { desc : ''  },
									kacaDepanKiri : { desc : ''  }, 
									pintuDepanKiri : { desc : ''  },
									sideSkirtKiri : { desc : ''  },
									kacaBelakangKiri : { desc : ''  },
									kacaMiniBelakangKiri : { desc : ''  },
									pintuBelakangKiri : { desc : ''  },
									sideRoofKiri : { desc : ''  },
									fenderBelakangKiri : { desc : ''  },
									tankiMobil : { desc : ''  },
									rodaBelakangKiri :{ desc : ''  },
								},
								right : {
									rodaBelakangKanan :{ desc : ''  },
									fenderBelakangKanan : { desc : ''  },
									sideRoofKanan : { desc : ''  },
									pintuBelakangKanan : { desc : ''  },
									kacaMiniBelakangKanan : { desc : ''  },
									kacaBelakangKanan : { desc : ''  },
									sideSkirtKanan : { desc : ''  },
									kacaDepanKanan : { desc : ''  }, 
									pintuDepanKanan : { desc : ''  },
									rodaDepanKanan : { desc : ''  },
									fenderDepanKanan : { desc : ''  },		
								}
							},
							minibus : {
								front : {
									carWindowDepan : { desc : ''  },
									kapMesin : { desc : ''  },
									headLightKanan : { desc : ''  },
									grill : { desc : ''  } ,
									emblem : { desc : ''  },
									headLightKiri : { desc : ''  },
									bumperDepan : { desc : ''  },
									fogLightKiri : { desc : ''  },
									fogLightKanan : { desc : ''  },
									spionDepanKiri : { desc : ''  },
									spionDepanKanan : { desc : ''  },
								},
								rear : {
									carWindowBelakang : { desc : ''  },
									bagasi : { desc : ''  },
									backLightKiri : { desc : ''  },
									emblem : { desc : ''  },
									backLightKanan : { desc : ''  },
									bumperBelakang : { desc : ''  },
									bumperLightKiri : { desc : ''  },
									bumperLightKanan : { desc : ''  },
								},
								atap : {
									atapMobil : { desc : ''  },
									sunRoof1 : { desc : ''  },
									sunRoof2 : { desc : ''  }
								},
								left : {
									fenderDepanKiri : { desc : ''  },		
									rodaDepanKiri : { desc : ''  },
									kacaDepanKiri : { desc : ''  }, 
									pintuDepanKiri : { desc : ''  },
									sideSkirtKiri : { desc : ''  },
									kacaPalingBelakangKiri : { desc : '' },
									kacaBelakangKiri : { desc : ''  },
									kacaMiniDepanKiri : { desc : ''  },
									pintuBelakangKiri : { desc : ''  },
									sideRoofKiri : { desc : ''  },
									fenderBelakangKiri : { desc : ''  },
									tankiMobil : { desc : ''  },
									rodaBelakangKiri :{ desc : ''  },
								},
								right : {
									rodaBelakangKanan :{ desc : ''  },
									fenderBelakangKanan : { desc : ''  },
									sideRoofKanan : { desc : ''  },
									pintuBelakangKanan : { desc : ''  },
									kacaMiniDepanKanan : { desc : ''  },
									kacaBelakangKanan : { desc : ''  },
									kacaPalingBelakangKanan : { desc : '' },
									sideSkirtKanan : { desc : ''  },
									kacaDepanKanan : { desc : ''  }, 
									pintuDepanKanan : { desc : ''  },
									rodaDepanKanan : { desc : ''  },
									fenderDepanKanan : { desc : ''  },	
								}
							}
						}
					}
				},
				checklistSettings: null,
				startIndex : 0
			}
		},
		watch: {
			'data.customer_car.model' : function () {
				
				this.data.customer_car.car_id = this.data.customer_car.model.id
			},
			'data.customer_car.colour' : function () {
				this.data.customer_car.car_color_id = this.data.customer_car.colour.id
			},
		},
		components : {
			page1,
			page2,
			page3,
			page4,
			page5,
			page6,
			page7,
			page8,
			page9,
			UploadImage
		},
		mounted () {
			let user = this.$store.state.userData.userData
			this.loadChecklistSettings ()
			this.data.CSO = this.$store.state.userData.userData.name
			
			// alert(user.role[0].name)

			if (user.role.length > 0 && user.role[0].name == 'Tanda Terima Only') {
				this.$swal.fire({
				title: 'Lewatkan Input Data?',
				icon: 'question',
				confirmButtonText : 'Lanjut Ke Pengecekan Kondisi',
				cancelButtonText : 'Tidak, Saya Ingin Input Data',
				cancelButtonColor : 'red',
				showCancelButton: true
				}).then((result) => {
					if (result.value) {
						this.skip = true
						this.$set(this.data , 'registration', null)
						this.page++;
						this.startIndex = 1

						// if(this.$store.state.setWorkOrder){
						// 	this.$swal.fire({
						// 	title: 'Ada Pengecekan Work Order yang belum selesai. Apakah anda mau Bikin Tanda Terima Baru ?',
						// 	icon: 'question',
						// 	confirmButtonText : 'Bikin Tanda Terima',
						// 	cancelButtonText : 'Lanjutkan Sebelumnya',
						// 	cancelButtonColor : 'red',
						// 	showCancelButton: true
						// 	}).then((result) => {
						// 		if (result.value) {
						// 			this.$store.state.setWorkOrder = null
						// 		}
						// 		else {
						// 			this.data = this.$store.state.setWorkOrder

						// 		}
						// 	})
						// }

					}
				})
			}
			else {
				this.getRecordedCondition = true
				console.log(this.$store.state.lastData)
				// if(this.$store.state.lastData) {
				// 	this.$swal.fire({
				// 	title: 'Load Save Data?',
				// 		text: "System mendeteksi ada data yang disimpan tetapi belum terunggah! Apakah anda mau mengulang atau melanjuti data sebelumnya?",
				// 		icon: 'warning',
				// 		confirmButtonText : 'Lanjut ',
				// 		cancelButtonText : 'Ulang',
				// 		cancelButtonColor : 'red',
				// 		showCancelButton: true
				// 	}).then((result) => {
				// 		if (result.value) {
				// 			this.data = this.$store.state.lastData
				// 			delete this.data.form_code
				
				// 		}
				// 		else {
				// 			this.$store.state.lastData = this.data
				// 			delete this.data.form_code
				// 		}
				// 	})
				// } 
				// else {
				// 	this.$store.state.lastData = this.data
				// }

				
			}

			

			
		},
		methods : {
			inputCQ(message) {
				this.customerRequest = message
				console.log(this.customerRequest)
			},
			nextPage (check) {
				// console.log(check)
				if(check) {
					this.data.conditionChecked = false
					this.createWorkOrder('periksa nanti')
					
				}
				
				else {

					this.data.conditionChecked = true
					

					this.page++

					if(this.page == 9) {
						this.processData()
						return
					}


					if(this.page == 8) {
						this.modal.type = 'checkList'
					}
					else {
						this.modal.type = null
					}
					
				}
					
			},
			async individualCorrection (i) {
				let processedData = await this.structureData(i)
				let curIndex = i - 1
				let step = 100 / 8 

				this.$set(this.valid, curIndex, 'Process')

				try {
					if((i == 0 && this.data.form_code.includes('Q')) || !this.data.form_code) {
						let resp = await this.$http.post('/api/v1/workorder', {data : processedData})
						this.data.form_code = resp.data.data.form_code
						this.$store.state.setWorkOrder = this.data
						this.modal.show = false
						this.apiLoading = false

						if(i == 9) {
							this.$store.state.lastData = null
						}

						this.$set(this.valid, curIndex, true)
						this.progressValue += step
					}
					else {
						let resp = await this.$http.patch('/api/v1/workorder/' + this.data.form_code , {data : processedData})
						this.$store.dispatch('triggerAlert' , [true , 'Data Berhasil Disimpan!'])
						if(i == 8) {
							this.modal.type = 'checkList'
						}
						else {
							this.modal.type = null
						}

						if(i == 9) {
							this.$store.state.lastData = null
							this.$store.state.setWorkOrder = null
						}
						this.apiLoading = false
						this.$set(this.valid, curIndex, true)
						this.progressValue += step
					}
					

				}
				catch(err) {
					console.log(err.response)
					this.$set(this.valid, curIndex, false)
					let errMessage = err.response.data.data
					if(typeof errMessage == 'string') {
						if(errMessage.includes('registration'))
							errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

						this.$store.dispatch('triggerAlert' , [false , errMessage])
						this.apiLoading = false
					}
					else if(errMessage.nativeError) {
						this.$store.dispatch('triggerAlert' , [false , errMessage.nativeError.sqlMessage])
					}
					else {
						let keys = Object.keys(errMessage)
						let arr = []
						for(var i = 0 ; i < keys.length ; i++) {
							let message = errMessage[keys[i]][0].message
							arr.push(`${this.translate(keys[i])} ${message}`)

						}
						this.$store.dispatch('triggerAlert' , [false , arr])
						this.apiLoading = false
					}
				}
			},
			async structureData(page) {

				let data = JSON.parse(JSON.stringify(this.data))
				let processedData = {}
				let keys = Object.keys(this.data)
				if(page == 1) {
					for(var i = 0;  i < keys.length ; i++) {
						if(keys[i] != 'condition')
							processedData[keys[i]] = data[keys[i]]
					}
					console.log(processedData.customer)
					processedData.customer.ktp = processedData.customer.ktp.split(" ").join("")

					processedData.customer_car.chassis_number = processedData.customer_car.chassis_number.trim()
					processedData.customer_car.engine_number = processedData.customer_car.engine_number.trim()

					delete processedData.customer_car.brand
					delete processedData.customer_car.type
					delete processedData.customer.created_at
					delete processedData.customer.last_date
					delete processedData.customer_car.colour
					delete processedData.customer_id
					delete processedData.customer_car.model
					delete processedData.customer_car.current_km
					delete processedData.customer_car.last_km
					if(!processedData.customer.email) delete processedData.customer.email
					// else processedData.customer_car.email = processedData.customer.email
					
					processedData.finishDate = new moment().format('Y-MM-DD')
					
					
					processedData.check_by = this.$store.state.userData.userData.name
					processedData.condition = {}
					processedData.condition.customerRequest = this.customerRequest
					
				}
				else if(page == 2) {
					processedData.condition = {
						accu: data.condition.accu,
						fuel: data.condition.fuel
					}

					if(this.skip) {
						delete processedData.customer_car
						processedData.skip = true
						processedData.finishDate = new moment().format('Y-MM-DD')
						processedData.condition.last_km = this.data.current_km
						processedData.registration = this.data.registration
						
					}
					else {
						processedData.customer = data.customer
						processedData.customer.ktp = processedData.customer.ktp.split(" ").join("")
						processedData.customer_car = data.customer_car
						
						// Remove Trailing Spaces
						processedData.customer_car.chassis_number = processedData.customer_car.chassis_number.trim()
						processedData.customer_car.engine_number = processedData.customer_car.engine_number.trim()
						processedData.customer.email = processedData.customer.email.trim();

						delete processedData.customer_car.brand
						delete processedData.customer_car.type
						delete processedData.customer.created_at
						delete processedData.customer.last_date
						delete processedData.customer_car.colour
						delete processedData.customer_id
						delete processedData.customer_car.model
						processedData.customer_car.current_km = processedData.customer_car.last_km = parseInt(processedData.customer_car.current_km.split(",").join(""))
					}
					
				}
				else if ( page > 2 && page < 8) {
					let arr = ['front' , 'left' , 'rear' , 'right' , 'atap']
					processedData.condition = {}
					processedData.condition.figure = {} 
					processedData.condition.figure[arr[page - 3]] = data.condition.figure[this.carType][arr[page - 3]]
					processedData.condition.figureOverall = {}
					processedData.condition.figureOverall[arr[page - 3]] = data.condition.figureOverall[this.carType][arr[page - 3]]

					
				}
				else if (page == 8) {
					processedData.condition = {}
					processedData.condition.checklist = data.condition.checklist
					processedData.condition.ttdCustomer = data.condition.ttdCustomer
				}
				return processedData
				
			},
			async processData () {
				let step = 100 / 8
				let data = JSON.parse(JSON.stringify(this.data))
				

				if(this.apiLoading) {
					this.$store.dispatch('triggerAlert' , [false , 'Please Wait...'])
					return
				}
				
				this.apiLoading = true

				
				for(var i = this.startIndex ; i <= 8 ; i++) {
					let processedData = await this.structureData(i)
					let curIndex = i - 1

					this.$set(this.valid, curIndex, 'Process')

					try {
						if(!this.data.form_code) {
							let resp = await this.$http.post('/api/v1/workorder', {data : processedData})
							this.data.form_code = resp.data.data.form_code
							this.$store.state.setWorkOrder = this.data
							this.modal.show = false
							this.apiLoading = false

							if(i == 9) {
								this.$store.state.lastData = null
							}

							this.$set(this.valid, curIndex, true)
							this.progressValue += step
						}
						else {
							let resp = await this.$http.patch('/api/v1/workorder/' + this.data.form_code , {data : processedData})
							this.$store.dispatch('triggerAlert' , [true , 'Data Berhasil Disimpan!'])
							if(i == 8) {
								this.modal.type = 'checkList'
							}
							else {
								this.modal.type = null
							}

							if(i == 9) {
								this.$store.state.lastData = null
								this.$store.state.setWorkOrder = null
							}
							this.apiLoading = false
							this.$set(this.valid, curIndex, true)
							this.progressValue += step
						}
						

					}
					catch(err) {
						console.log(err.response)
						this.$set(this.valid, curIndex, false)
						let errMessage = err.response.data.data
						if(typeof errMessage == 'string') {
							if(errMessage.includes('registration'))
								errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

							this.$store.dispatch('triggerAlert' , [false , errMessage])
							this.apiLoading = false
						}
						else if(errMessage.nativeError) {
							this.$store.dispatch('triggerAlert' , [false , errMessage.nativeError.sqlMessage])
						}
						else {
							let keys = Object.keys(errMessage)
							let arr = []
							for(var i = 0 ; i < keys.length ; i++) {
								let message = errMessage[keys[i]][0].message
								arr.push(`${this.translate(keys[i])} ${message}`)

							}
							this.$store.dispatch('triggerAlert' , [false , arr])
							this.apiLoading = false
						}
					}
					
				}
				// console.log(processedData)

				// if(!data.form_code) {
				// 	this.$http.post('/api/v1/workorder', {data : processedData})
				// 	.then((resp)=> {
				// 		this.data.form_code = resp.data.data.form_code
				// 		this.$store.state.setWorkOrder = this.data
				// 		this.modal.show = false
				// 		this.apiLoading = false
				// 		this.page++
				// 		if(this.page == 8) {
				// 			this.modal.type = 'checkList'
				// 		}
				// 		else {
				// 			this.modal.type = null
				// 		}

				// 		if(this.page == 9) {
				// 			this.$store.state.lastData = null
				// 		}

				// 	})
				// 	.catch(async (err) => {
				// 		console.log(err.response)
				// 		let errMessage = err.response.data.data
				// 		if(typeof errMessage == 'string') {
				// 			if(errMessage.includes('registration'))
				// 				errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

				// 			this.$store.dispatch('triggerAlert' , [false , errMessage])
				// 			this.apiLoading = false
				// 		}
				// 		else {
				// 			let keys = Object.keys(errMessage)
				// 			let arr = []
				// 			for(var i = 0 ; i < keys.length ; i++) {
				// 				let message = errMessage[keys[i]][0].message
				// 				arr.push(`${this.translate(keys[i])} ${message}`)

				// 			}
				// 			this.$store.dispatch('triggerAlert' , [false , arr])
				// 			this.apiLoading = false
				// 		}
						
				// 	})
				// }
				// else {
				// 	this.$http.patch('/api/v1/workorder/' + this.data.form_code , {data : processedData})
				// 	.then((resp) => {
				// 		this.$store.dispatch('triggerAlert' , [true , 'Data Berhasil Disimpan!'])
				// 		this.page++
				// 		if(this.page == 8) {
				// 			this.modal.type = 'checkList'
				// 		}
				// 		else {
				// 			this.modal.type = null
				// 		}

				// 		if(this.page == 9) {
				// 			this.$store.state.lastData = null
				// 			this.$store.state.setWorkOrder = null
				// 		}
				// 		this.apiLoading = false
				// 	})
				// 	.catch((err) => {
				// 		console.log(err.response)
				// 		let errMessage = err.response.data.data
				// 		if(typeof errMessage == 'string') {
				// 			if(errMessage.includes('registration'))
				// 				errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

				// 			this.$store.dispatch('triggerAlert' , [false , errMessage])
				// 			this.apiLoading = false
				// 		}
				// 		else if(errMessage.nativeError) {
				// 			this.$store.dispatch('triggerAlert' , [false , errMessage.nativeError.sqlMessage])
				// 		}
				// 		else {
				// 			let keys = Object.keys(errMessage)
				// 			let arr = []
				// 			for(var i = 0 ; i < keys.length ; i++) {
				// 				let message = errMessage[keys[i]][0].message
				// 				arr.push(`${this.translate(keys[i])} ${message}`)

				// 			}
				// 			this.$store.dispatch('triggerAlert' , [false , arr])
				// 			this.apiLoading = false
				// 		}
				// 	})
				// }
			},
			backPage () {
				this.page--
			},
			uploadImage () {
				this.modal.show = true
			},
			changeCarType (carType) {
				this.carType = carType
			},
			loadChecklistSettings () {
				this.$http.get('/api/v1/workorder/settings')
				.then((resp) => {
					this.checklistSettings = resp.data.data
					let checklist = {}

					for (var i = 0 ; i < this.checklistSettings.length ; i++) {
						checklist[this.checklistSettings[i].name] = {
							condition : '',
							img : null
						}
					}

					this.data.condition.checklist = Object.assign({} , checklist)
				})
				.catch((err) => {
					console.log(err)
				})
			},
			translate(text) {
				let obj = {
					chassis_number : 'Nomor Rangka',
					engine_number : 'Nomor Mesin',
					registration : 'Nomor Polisi Mobil',
					address : 'Alamat'
				}

				return obj[text] ? obj[text] : text
			},
			createWorkOrder(image) {
				this.apiLoading = true
				let data = JSON.parse(JSON.stringify(this.data))

				if(this.data.customer) {
					delete data.customer_car.brand
					delete data.customer_car.type
					delete data.customer_car.colour
					delete data.customer.created_at
					delete data.customer.last_date
					
					delete data.customer_id
					delete data.customer_car.model

					if(!data.customer.email) data.customer.email = ''
					data.customer.ktp = data.customer.ktp.split(" ").join("")
				}

				
				data.finishDate = new moment().format('Y-MM-DD')
				// data.customer_car.price = parseFloat(data.customer_car.price.split(',').join(''))

				if(!image && !this.skip) {
					data.check_by = this.$store.state.userData.userData.name
					
					// delete data.customer.phone_number
					data.customer_car.current_km = data.customer_car.last_km = parseInt(data.customer_car.current_km.split(",").join(""))

					data.condition.figureOverall = data.condition.figureOverall[this.carType]
					data.condition.figure = data.condition.figure[this.carType]
					data.conditionChecked = true
					data.condition.customerRequest = this.customerRequest
					// data.check_by = this.$store.state.userData.userData.name
				}
				else if(this.skip) {
					data.check_by = this.$store.state.userData.userData.name
					data.condition.figureOverall = data.condition.figureOverall[this.carType]
					data.condition.figure = data.condition.figure[this.carType]
					data.conditionChecked = true
					data.condition.customerRequest = this.customerRequest
					data.skip = true
				}
				else {
					// data.CSO = this.$store.state.userData.userData.name
					delete data.condition
					data.customer_car.current_km = data.customer_car.current_km != '' ? parseInt(data.customer_car.current_km) : 0
					data.customer_car.last_km = data.customer_car.current_km
					data.conditionChecked = false
					
					data.condition = {
						customerRequest : this.customerRequest,
						figureOverall : {
							front : {
								desc : 'No Image',
								image : ['test image']
							}
						}
					}
				}
				
				// console.log(data)

				if(data.serviceType == 'Beli Sparepart')
					data.customer_car ? delete data.customer_car : null
				else if (data.serviceType == 'Process Mobil') {
					!data.customer.name || data.customer.name == '' ? delete data.customer : null
				}

				this.$http.post('/api/v1/workorder', {data : data})
				.then((resp)=> {
					this.data.form_code = resp.data.data.form_code
					this.$store.state.lastData = null
					this.page = 9
					this.modal.show = false
					this.apiLoading = false

				})
				.catch(async (err) => {
					console.log(err.response)
					let errMessage = err.response.data.data
					if(typeof errMessage == 'string') {
						if(errMessage.includes('registration'))
							errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

						this.$store.dispatch('triggerAlert' , [false , errMessage])
						this.apiLoading = false
					}
					else {
						let keys = Object.keys(errMessage)
						let arr = []
						for(var i = 0 ; i < keys.length ; i++) {
							let message = errMessage[keys[i]][0].message
							arr.push(`${this.translate(keys[i])} ${message}`)

						}
						this.$store.dispatch('triggerAlert' , [false , arr])
						this.apiLoading = false
					}
					
				})
			}
		}
	}
</script>

<style scoped>
	.Aligner {
	display: flex;
	align-items: center;
	justify-content: center;
	}
  
</style>

